import { render, staticRenderFns } from "./EventTriggerSection.vue?vue&type=template&id=6704cb22&scoped=true"
import script from "./EventTriggerSection.vue?vue&type=script&lang=js"
export * from "./EventTriggerSection.vue?vue&type=script&lang=js"
import style0 from "./EventTriggerSection.vue?vue&type=style&index=0&id=6704cb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704cb22",
  null
  
)

export default component.exports